/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { EmployerRelationshipData } from '../models/employer-relationship-data';

@Injectable({
  providedIn: 'root',
})
export class EmployerRelationshipsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation employerRelationshipsGet
   */
  static readonly EmployerRelationshipsGetPath = '/api/EmployerRelationships/Get';

  /**
   * Munkáltatók lekérése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `employerRelationshipsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  employerRelationshipsGet$Plain$Response(params?: {
    Search?: string;
    EmployerId?: number;
    OrderColumns?: Array<string>;
    PageIndex?: number;
    PageSize?: number;
    MaxPageSize?: number;
    SkipTotalItemCount?: boolean;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<EmployerRelationshipData>>> {

    const rb = new RequestBuilder(this.rootUrl, EmployerRelationshipsService.EmployerRelationshipsGetPath, 'get');
    if (params) {
      rb.query('Search', params.Search, {});
      rb.query('EmployerId', params.EmployerId, {});
      rb.query('OrderColumns', params.OrderColumns, {});
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('MaxPageSize', params.MaxPageSize, {});
      rb.query('SkipTotalItemCount', params.SkipTotalItemCount, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<EmployerRelationshipData>>;
      })
    );
  }

  /**
   * Munkáltatók lekérése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `employerRelationshipsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  employerRelationshipsGet$Plain(params?: {
    Search?: string;
    EmployerId?: number;
    OrderColumns?: Array<string>;
    PageIndex?: number;
    PageSize?: number;
    MaxPageSize?: number;
    SkipTotalItemCount?: boolean;
  },
  context?: HttpContext

): Observable<Array<EmployerRelationshipData>> {

    return this.employerRelationshipsGet$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<EmployerRelationshipData>>) => r.body as Array<EmployerRelationshipData>)
    );
  }

  /**
   * Munkáltatók lekérése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `employerRelationshipsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  employerRelationshipsGet$Response(params?: {
    Search?: string;
    EmployerId?: number;
    OrderColumns?: Array<string>;
    PageIndex?: number;
    PageSize?: number;
    MaxPageSize?: number;
    SkipTotalItemCount?: boolean;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<EmployerRelationshipData>>> {

    const rb = new RequestBuilder(this.rootUrl, EmployerRelationshipsService.EmployerRelationshipsGetPath, 'get');
    if (params) {
      rb.query('Search', params.Search, {});
      rb.query('EmployerId', params.EmployerId, {});
      rb.query('OrderColumns', params.OrderColumns, {});
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('MaxPageSize', params.MaxPageSize, {});
      rb.query('SkipTotalItemCount', params.SkipTotalItemCount, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<EmployerRelationshipData>>;
      })
    );
  }

  /**
   * Munkáltatók lekérése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `employerRelationshipsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  employerRelationshipsGet(params?: {
    Search?: string;
    EmployerId?: number;
    OrderColumns?: Array<string>;
    PageIndex?: number;
    PageSize?: number;
    MaxPageSize?: number;
    SkipTotalItemCount?: boolean;
  },
  context?: HttpContext

): Observable<Array<EmployerRelationshipData>> {

    return this.employerRelationshipsGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<EmployerRelationshipData>>) => r.body as Array<EmployerRelationshipData>)
    );
  }

}
